import { gql } from "@apollo/client";

export const MUTATION_EXPORT_SALE = gql`
  mutation exportSale($saleId: ID!, $exportType: ExportSaleType!) {
    exportSale(saleId: $saleId, exportType: $exportType) {
      success
    }
  }
`;

export const QUERY_EXPORT_RAW_SALE_JSON = gql`
  query exportRawSaleJSON($saleId: ID!) {
    exportRawSaleJSON(saleId: $saleId)
  }
`;
